<template>
  <div class="gmf-dropdown-anchor" :class="parentClass">
    <div class="gmf-modal-overlay" :class="{'gmf-invisible': hideOverlay}" @click.prevent.stop="close" @touchdown.stop @mousedown.stop @touchmove.stop.prevent />
    <slot name="anchor" />
    <div class="gmf-dropdown-content" ref="content" :style="containerStyle">
      <slot />
    </div>
  </div>
</template>

<style>
.gmf-dropdown-anchor {
  position: relative;
  z-index: var(--gmf-modal-z-index);
}
.gmf-dropdown-content {
  padding: var(--gmf-p-3);
  position: absolute;
  top: 100%;
  left: 0;
  z-index: calc(var(--gmf-modal-z-index));
  max-width: 99vw;
  max-width: 99.9vw;
}
.gmf-dropdown-anchor .gmf-modal-overlay {
  overflow: auto;
}
</style>

<script>
export default {
  data () {
    return {
      xOffset: 0,
    };
  },
  mounted () {
    this.$nextTick(this.fixPosition);
  },
  props: {
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    parentClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    close () {
      this.$emit('close');
    },
    fixPosition () {
      const { x, width } = this.$refs.content.getBoundingClientRect();
      if (x < 0) { // too far to the left
        this.xOffset = Math.round(-x);
      } else if (x + width > document.body.clientWidth) {
        this.xOffset = Math.round(document.body.clientWidth - (x + width));
      }
    },
  },
  computed: {
    containerStyle () {
      return {
        transform: 'translatex(' + this.xOffset + 'px)',
      };
    },
  },
};
</script>
